import EventTitle from './EventTitle'
import { formatDate } from 'Utils/Dates'
import { revisionMapping } from './eventMapping'

const EMPTY_VALUE = '--'

const formatted = (value, format) => {
  if (!value) return EMPTY_VALUE
  if (Array.isArray(value)) return (
    <ul className="mb-0">
      {value.map(item => <li key={item}>{item?.display || item}</li>)}
    </ul>
  )

  return formatDate(value?.display, { format }) || value || EMPTY_VALUE
}

const GroupedChanges = ({ changes, eventConfig, format, id }) => (
  <div className="grouped-changes">
    {changes.map(change => {
      const config = revisionMapping[change.name] || eventConfig

      return (
        <div className="change" key={`${id}-${change.name}`}>
          <EventTitle icon={config?.icon} label={config?.label || change.name} subtitle={config?.subtitle} />

          <div className="d-flex justify-content-between">
            <div className="w-50">
              <span className="text-muted d-block">From:</span>
              {formatted(change.from, format)}
            </div>

            <div className="w-50">
              <span className="text-muted d-block">To:</span>
              {formatted(change.to, format)}
            </div>
          </div>
        </div>
      )
    })}
  </div>
)

export default GroupedChanges
